import useGooglePayFundingOptions from 'features/moveMoney/screens/GooglePay/hooks/useGooglePayFundingOptions';
import React from 'react';
import { useTranslation } from 'react-i18next';
import WalletPayLimitInfo from 'shared/patterns/walletPay/screens/WalletPayLimitInfo/WalletPayLimitInfo';

const GooglePayLimitInfo = () => {
  const { t: translatedText } = useTranslation('moveMoney', {
    keyPrefix: 'googlePay',
  });

  const {
    data: {
      limitInformation: {
        dailyLimitInformation,
        monthlyLimitInformation,
        disclaimer,
      },
    },
  } = useGooglePayFundingOptions('cache-only');

  return (
    <WalletPayLimitInfo
      title={translatedText('limits')}
      dailyLimitInformation={dailyLimitInformation}
      monthlyLimitInformation={monthlyLimitInformation}
      disclaimer={disclaimer}
    />
  );
};

export default GooglePayLimitInfo;
